// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "main.expanded[data-v-8889d1dc]{margin-left:56px}main.expanded header#upp-bar[data-v-8889d1dc]{margin-left:56px;width:calc(100% - 56px)!important}main.reduced[data-v-8889d1dc]{margin-left:256px}main.reduced header#upp-bar[data-v-8889d1dc]{margin-left:256px;width:calc(100% - 256px)!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
